import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { ImageBlk, Buttton, Acccordion } from "../components";
import heroImg from "../assets/images/hero.png";
import heroImg1 from "../assets/images/illustration.png";
import {
  PiClockClockwise,
  PiFiles,
  PiChats,
  PiCreditCard,
  PiCaretDownBold,
  PiCaretUpBold,
} from "react-icons/pi";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { TbFileUpload } from "react-icons/tb";
import { CiMedicalCase } from "react-icons/ci";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { useSnackBar, } from "../contexts";

const LandingPage = () => {
  const { t } = useTranslation();
  const { showSnackBar } = useSnackBar();

  const handleClick = () => {

    showSnackBar("This is a success message!",)
  };

  const items = [
    {
      icon: <PiClockClockwise />,
      title: t("doctor.landing-page.a-r-o-s"),
      content: t("doctor.landing-page.a-r-o-s-content"),
    },
    {
      icon: <CiMedicalCase />,
      title: t("doctor.landing-page.e-p-h"),
      content: t("doctor.landing-page.e-p-h-content"),
    },
    {
      icon: <TbFileUpload />,
      title: t("doctor.landing-page.A-I"),
      content: t("doctor.landing-page.A-I-content"),
    },
    {
      icon: <PiFiles />,
      title: t("doctor.landing-page.s-d-m"),
      content: t("doctor.landing-page.s-d-m-content"),
    },
    {
      icon: <PiChats />,
      title: t("doctor.landing-page.c-s"),
      content: t("doctor.landing-page.c-s-content"),
    },
    {
      icon: <PiCreditCard />,
      title: t("doctor.landing-page.o-p"),
      content: t("doctor.landing-page.o-p-content"),
    },
  ];
  const items1 = [
    {
      no: "01",
      title: t("doctor.landing-page.c-a-a-t-p-y-d"),
    },
    { no: "02", title: t("doctor.landing-page.setup_fees_for_services") },
    { no: "03", title: t("doctor.landing-page.setup_schedules_services") },
    { no: "04", title: t("doctor.landing-page.setup_invoicing_information") },
    { no: "05", title: t("doctor.landing-page.link_schedule_to_website") },
  ];

  const list = [
    [
      t("doctor.landing-page.list.online_schedule_personal_consultations"),
      t("doctor.landing-page.list.online_schedule_online_consultations"),
      t("doctor.landing-page.list.video_online_consultations"),
      t("doctor.landing-page.list.automated_mail_reminders"),
      t("doctor.landing-page.list.automated_phone_reminders"),
      t("doctor.landing-page.list.online_document_management"),
      t("doctor.landing-page.list.secure_data_backup"),
      t("doctor.landing-page.list.automated_patient_communication"),
      t("doctor.landing-page.list.appointment_booking_guest_patients"),
      t("doctor.landing-page.list.integrated_reporting"),
      t("doctor.landing-page.list.fully_integrated_patient_management"),
      t("doctor.landing-page.list.fully_protocolled_patient_interactions"),
      t("doctor.landing-page.list.chat_service_with_patients"),
    ],
    [
      t("doctor.landing-page.list.automated_invoices_fee"),
      t("doctor.landing-page.list.automated_online_payments_fee"),
    ],
    [
      t("doctor.landing-page.list.asynchronous_chat_consultation"),
      t("doctor.landing-page.list.online_consultation_service"),
    ],
    [
      t("doctor.landing-page.list.multiple_calendars"),
      t("doctor.landing-page.list.all_services_included"),
      t("doctor.landing-page.list.custom_fees_extra_services"),
    ],
  ];
  const items2 = [
    {
      title: (
        <>
          {t("standard")} <br /> {t("doctor.landing-page.standard_plan")}
        </>
      ),
      content: (
        <div>
          <div>
            <ul className="exado-acc-ul">
              {list[0].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="list-heading exado-title-three">
              {t("doctor.landing-page.s-t-a-c-e")}
            </h4>
            <ul>
              {list[1].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="list-heading exado-title-three">
              {t("doctor.landing-page.s-y-g-p-f-b-u")}
            </h4>
            <ul>
              {list[2].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ),
    },

    {
      title: (
        <>
          {t("premium")} <br /> {t("doctor.landing-page.premium_plan")}
        </>
      ),
      content: (
        <div>
          <div>
            <ul>
              {list[0].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="list-heading exado-title-three">
              {t("doctor.landing-page.s-t-a-c-e")}
            </h4>
            <ul>
              {list[1].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="list-heading exado-title-three">
              {t("doctor.landing-page.s-y-g-p-f-b-u")}
            </h4>
            <ul>
              {list[2].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: (
        <>
          {t("enterprise")} <br /> {t("doctor.landing-page.enterprise_plan")}
        </>
      ),
      content: (
        <div>
          <div>
            <ul>
              {list[3].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="exado-title-three">
              {t("doctor.landing-page.s-y-g-p-f-b-u")}
            </h4>
            <ul>
              {list[2].map((item, index) => (
                <li key={index} className="list">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="btnblk ">
            <Buttton.Buttton
              type="button"
              children={t("get_in_touch")}
              onClick={handleClick}
              className="btn-solid-Aqua_Teal "
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Container className="exado-container" fluid>
      <Row className="exado-row exado-bg-img">
        <Col className="exado-col" lg={12}>
          <div className="exadoheroBlk">
            <h1 className="exado-title-one">
              {t("doctor.landing-page.title")}
            </h1>
            <h2 className="exado-subTitle-one">
              {t("doctor.landing-page.subTitleone")} <br />
              {t("doctor.landing-page.subTitletwo")}
            </h2>
            <div className="btnBLk">
              <Buttton.Buttton
                type="button"
                children={t("doctor.landing-page.login_and_go")}
                onClick={handleClick}
                className="btn-solid-Aqua_Teal"
              />
              <Buttton.Buttton
                type="button"
                children={t("doctor.landing-page.sign_up")}
                onClick={handleClick}
                className="btn-solid-Aqua_Teal"
              />
              <Buttton.Buttton
                type="button"
                children={t("doctor.landing-page.i_am_a_patient")}
                onClick={handleClick}
                className="btn-solid-Aqua_Teal"
              />
              <Buttton.Buttton
                type="button"
                children={t("doctor.landing-page.request_a_demo")}
                onClick={handleClick}
                className="btn-solid-Aqua_Teal"
              />
            </div>
          </div>
        </Col>
        <Col className="exado-col" lg={12}>
          <ImageBlk.ImageBlk
            src={heroImg}
            alt="hero"
            classNames={["exadoheroBlk", "exadoheroimg"]}
          />
        </Col>
      </Row>
      <Row className="exado-row">
        <Col className="exado-col" lg={8}>
          <h2 className="exado-title-two">
            {" "}
            {t("doctor.landing-page.r-a-c")}{" "}
          </h2>
          <h4 className="exado-subTitle-two">
            {t("doctor.landing-page.e-h-s")}
          </h4>
        </Col>
        <Col lg={12}>
          <Acccordion.Acccordion
            items={items}
            defaultActiveKey={["0"]}
            alwaysOpen={false}
            className="acccordian dcs"
            Open={<FaCaretUp className="acc-icn" />}
            Close={<FaCaretDown className="acc-icn" />}
          />
        </Col>
      </Row>
      <Row className="exado-row">
        <Col className="exado-col" lg={8}>
          <h2 className="exado-title-two">
            {t("doctor.header.nav.how_its_works")} ?
          </h2>
          <p className="exado-subTitle-two">
            {t("doctor.landing-page.how_its_works-subTitle")}
          </p>
        </Col>
        <Col lg={12}>
          <div>
            {items1.map((item) => (
              <div key={item.no} className="exado-works-subBlk">
                <h4 className="exado-title-four">{item.no}</h4>
                <p className="exado-works-title exado-title-three">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </Col>
      </Row>
      <Row className="exado-row">
        <Col className="exado-col" lg={8}>
          <h2 className="exado-title-two">
            {t("doctor.header.nav.payment_plan")}
          </h2>
          <p className="exado-subTitle-two">
            {t("doctor.landing-page.payment_plan_subtitle")}
          </p>
        </Col>
        {items2?.map((item, index) => (
          <Col
            key={index}
            lg={index === items2.length - 1 ? 12 : 6}
            className="exado-acc-col"
          >
            <Acccordion.Acccordion
              items={[item]}
              defaultActiveKey={["0"]}
              alwaysOpen={false}
              className="acccordian payment-acc"
              Open={
                <div className="d-lg-none d-block">
                  <div className="acc-icons1">
                    <PiCaretUpBold className="acc-icn" />
                  </div>
                </div>
              }
              Close={
                <div className="d-lg-none d-block">
                  <div className="acc-icons1">
                    <PiCaretDownBold className="acc-icn" />
                  </div>
                </div>
              }
            />
          </Col>
        ))}
      </Row>
      <Row className="exado-row">
        <Col className="exado-col">
          <ImageBlk.ImageBlk src={heroImg1} alt="hero" classNames={["", ""]} />
        </Col>
      </Row>
      <Row className="exado-row">
        <Col className="exado-col" lg={8}>
          <h2 className="exado-title-two">
            {t("doctor.landing-page.our_team")}{" "}
          </h2>
          <p className="exado-subTitle-two">
            {t("doctor.landing-page.our_team_subTitle")}
          </p>
        </Col>
        <Col className="exado-col core-team-blk">
          <Link to="/" className="ct-link">
            {t("core_team")} <MdKeyboardArrowRight />
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default LandingPage;
